import React, {useState} from 'react';
import {useDispatch} from 'react-redux';
import {Icon} from 'semantic-ui-react';
import {groupBy, isUndefined} from 'lodash';
import {getColors, getCssBoards, getStatus} from './utils';
import {Actions} from '../../../common/actions';
import {ORDERS} from './constants';
import Loader from '../../../common/components/loader';
import DetailKanban from './detailModal';
import './styles.scss';

const {getKanbanOrderDetail} = Actions;

const BoardTitle = ({
  title = '',
  count = 0,
  handleSelectBoard = null,
  selectBoard,
}) => {
  const select = title === selectBoard ? null : title;
  const selectClassName = select ? 'selected' : '';

  return (
    <div
      className={`kanban-logistics-boards__items-title pointer ${selectClassName}`}
      onClick={() => handleSelectBoard(select)}
    >
      <p>
        {!select && <Icon name='arrow left' size='large' />}
        {title} ({count})
      </p>
    </div>
  );
};

const BoardCard = ({order, showModal, select}) => {
  const {chassis, orderId, description, color, motor, statusId} = order;

  return (
    <div
      onClick={() => showModal(true, order)}
      className='kanban-logistics-boards__item'
      style={{
        'background': getColors(statusId).bg,
        'border': `1px solid ${getColors(statusId).primary}`,
        'width': `${select ? '22%' : '100%'}`,
      }}
    >
      <div className='kanban-logistics-boards__item-content'>
        <p className='kanban-logistics-boards__item-title'>{orderId}</p>
        <p>{getStatus(statusId).toUpperCase()}</p>
      </div>
      <div className='kanban-logistics-boards__item-content'>
        <p>{chassis} </p>
        <p>{motor}</p>
      </div>
      <div className='kanban-logistics-boards__item-content'>
        <p>{description}</p>
        <p>{color ? color : ''}</p>
      </div>
    </div>
  );
};

const OrdersList = ({orders, handleModal}) => {
  const [selectBoard, setSelectBoard] = useState(null);

  function handleSelectBoard(title = null) {
    setSelectBoard(title);
  }

  function getOrdersByType() {
    const ordersByType = groupBy(orders, 'orderType');

    return {
      'DS': isUndefined(ordersByType.DS) ? [] : ordersByType.DS,
      'AC': isUndefined(ordersByType.AC) ? [] : ordersByType.AC,
      'CC': isUndefined(ordersByType.CC) ? [] : ordersByType.CC,
      'HU': isUndefined(ordersByType.HU) ? [] : ordersByType.HU,
    };
  }

  const ordersList = getOrdersByType();

  return ORDERS.map((order) => {
    const selectBoardClassName =
      selectBoard === order.value ? 'selected-board' : '';

    return (
      <div
        key={order.key}
        className={`kanban-logistics-boards__items ${selectBoardClassName}`}
        style={{'display': getCssBoards(selectBoard, order.value)}}
      >
        <BoardTitle
          title={order.value}
          selectBoard={selectBoard}
          count={ordersList[order.key].length}
          handleSelectBoard={handleSelectBoard}
        />
        <div
          className={`kanban-logistics-boards__items-content animated fadeInUp ${selectBoardClassName}`}
        >
          {ordersList[order.key].map((item) => (
            <BoardCard
              key={item.orderId}
              order={item}
              select={selectBoard === order.value}
              showModal={handleModal}
            />
          ))}
        </div>
      </div>
    );
  });
};

const KanbanCardsByOrderType = ({orders, loading, detail, loadingDetail}) => {
  const [open, setOpen] = useState(false);
  const [selectOrder, setSelectOrder] = useState(null);
  const dispatch = useDispatch();

  function handleModal(open, order = null) {
    setOpen(open);
    setSelectOrder(order);
    if (order) {
      dispatch(getKanbanOrderDetail(order.orderId));
    }
  }

  if (loading) {
    return <Loader />;
  }

  return (
    <div className='kanban-logistics-container'>
      <div className='kanban-logistics-boards'>
        <OrdersList orders={orders} handleModal={handleModal} />
      </div>
      {open && (
        <DetailKanban
          open={open}
          showModal={handleModal}
          selectOrder={selectOrder}
          detail={detail}
          loadingDetail={loadingDetail}
        />
      )}
    </div>
  );
};

export default KanbanCardsByOrderType;
